/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { observer } from 'mobx-react'
import { Modal } from 'antd-mobile'
import { Button, ButtonWrap, PopupBtnStyle } from '@styles/button.style'
import { ModalBg } from '@styles/base.style'
import useRootStore from '@store/useRootStore'
import oneFoldImg from '@assets/images/bg/character/one-fold-character.png'
import { MatchupDetailOneFoldWrap } from './index.style'

const MatchupDetailOneFold: React.FC = props => {
  const { globalStore } = useRootStore()
  const { visibleMatchupDetailOneFoldPopup } = globalStore

  const onCloseModal = () => {
    globalStore.setVisibleMatchupDetailOneFoldPopup(false)
  }


  return (
    <Fragment>
      <Modal
        transparent
        visible={visibleMatchupDetailOneFoldPopup}
        maskClosable={false}
        onClose={onCloseModal}
        className="custom-dialog middle-size"
      >

        <MatchupDetailOneFoldWrap>
          <div className="one-fold-info">
            <span className="one-fold-info--tit">1폴드 베팅이<br/>불가능한 클럽입니다.</span>
            <div className="one-fold-info--txt-box">
              <span className="sub-txt">추가벳은</span>
              <span className="point-txt">다른경기와 조합이&nbsp;</span>
              <span className="sub-txt">가능합니다.</span>
            </div>
          </div>
          <img src={oneFoldImg} alt="당황하는 여자 캐릭터" className="one-fold-img"/>
        </MatchupDetailOneFoldWrap>

        <ButtonWrap className="custom-dialog-btn-wrap">
          <Button secondary onClick={onCloseModal} css={PopupBtnStyle} className="one-button">
            확인
          </Button>
        </ButtonWrap>

        <ModalBg onClick={onCloseModal} />

      </Modal>
    </Fragment>
  )
}

export default observer(MatchupDetailOneFold)
